// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3dBHz","item":"PaymentsMobile_item__2Zl9k","label":"PaymentsMobile_label__jbpjH","amount":"PaymentsMobile_amount__1iaMr"};